import * as React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowRightLong } from "react-icons/fa6";

import Paper from "../../Components/Paper";
import StandardLink from "../../Components/StandardLink";

import { data } from "./Helper";

import "./Dashboard.scss";

const Dashboard = () => {
  return (
    <div>
      <Paper>
        <h1 className="mb-32">
          Bienvenue dans votre espace
        </h1>
        <Row xs={1} md={2} className="g-4">
          {data.map(({ label, value, Icon, path, className }, idx) => (
            <Col key={idx}>
              <div className={`card-dashboard ${className}`}>
                <div className="align-items-center row">
                  <div className="col">
                    <h5 className="mb-4">{label}</h5>
                    <h3 className="mb-0">{value}</h3>
                  </div>
                  <div className="col-sm-auto">
                    <Icon size="48" />
                  </div>
                </div>

                <StandardLink size="lg" to={path}>
                  {label}
                  <FaArrowRightLong />
                </StandardLink>
              </div>
            </Col>
          ))}
        </Row>
      </Paper>
    </div>
  );
};

export default Dashboard;
